import React, { useEffect } from 'react';
import { TilesContainer } from './Tiles.styles';
import { getAppContentConfiguration } from '../../hooks/tileHook';
import { scrollToPreviouslySelectedVehicle } from '@oneaudi/vtp-shared';

const Tiles: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { detailsPageUrlPattern, appContext } = getAppContentConfiguration();
  const detailsURL = detailsPageUrlPattern ?? '';

  // check after rendering if user was coming back to the page
  // and try to scoll to that position
  useEffect(() => {
    scrollToPreviouslySelectedVehicle();
  }, []);

  return (
    <TilesContainer
      data-testid="TilesContainer"
      className="sc-result-items"
      data-details-url={detailsURL}
      appContext={appContext}
    >
      <>{children}</>
    </TilesContainer>
  );
};

export default Tiles;
